<template>
  <div>
    <!-- Facebook Share button script -->
    <script
      type="application/javascript"
      async
      defer
      src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v8.0&appId=294215045357290"
      nonce="RtrsGQfn"
      crossorigin="anonymous"
    ></script>
    <!-- Twitter share button script -->
    <script
      type="application/javascript"
      src="https://platform.twitter.com/widgets.js"
      charset="utf-8"
    ></script>
    <!-- Youtube Subscribe button script -->
    <script type="application/javascript" src="https://apis.google.com/js/platform.js"></script>
    <h3 class="my-0" style="font-family: 'Recursive', sans-serif;"></h3>
    <h3 class="card-title my-0 h2 mb-3" style="font-family: 'Recursive', sans-serif;">Social Media</h3>
    <h5
      class="my-3"
      style="font-family: 'Comfortaa', cursive;"
    >Use these social media plugins to share the awareness campaign</h5>
    <a
      href="https://twitter.com/share?ref_src=twsrc%5Etfw"
      class="twitter-share-button"
      data-size="large"
      data-text="Coronavirus (Covid-19) - Let&#39;s Fight Corona - An awareness campaign by campus2community and national service scheme."
      data-url="https://c2c-covidawarenessprogram.web.app/"
      data-dnt="true"
      data-show-count="false"
    >Tweet</a>
    <span class="mx-1"></span>
    <iframe
      src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fc2c-covidawarenessprogram.web.app%2Faboutme&layout=button_count&size=large&appId=294215045357290&width=89&height=28"
      width="89"
      height="28"
      style="border:none;overflow:hidden"
      scrolling="no"
      frameborder="0"
      allowtransparency="true"
      allow="encrypted-media"
    ></iframe>
    <span class="mx-1"></span>
    <div
      class="g-ytsubscribe"
      data-channelid="UCHuA6ez77Kc96OlolkrjGKA"
      data-layout="full"
      data-count="default"
    ></div>
    <span class="mx-1"></span>
    <a
      target="_blank"
      title="Contact Us On WhatsApp"
      href="https://api.whatsapp.com/send?text=Covid Awareness Click on this link: https://c2c-covidawarenessprogram.web.app/"
    >
      <i class="fa fa-whatsapp" style="font-size:48px;color:#2DC100"></i>
    </a>
    <h6 style="font-family: 'Recursive', sans-serif;">Do your part.</h6>
    <h6 style="font-family: 'Recursive', sans-serif;">Stay home, stay safe.</h6>
  </div>
</template>

<script>
export default {
  mounted() {},
};
</script>

<style>
</style>